// Import useEffect for side effects and useLocation for route info
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// ScrollToTop component scrolls to top or anchor on route change
// Uses useLocation to detect path and hash changes
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If no hash, scroll to top of the page
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }

    // If hash exists, scroll to the element with the corresponding id
    const targetId = hash.replace("#", "");
    const target = document.getElementById(targetId);

    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [pathname, hash]);

  // This component does not render anything
  return null;
}

// Export the ScrollToTop component as default
export default ScrollToTop;
